import { render, staticRenderFns } from "./gPopUp.vue?vue&type=template&id=7b51481e&scoped=true&"
import script from "./gPopUp.vue?vue&type=script&lang=js&"
export * from "./gPopUp.vue?vue&type=script&lang=js&"
import style0 from "./gPopUp.vue?vue&type=style&index=0&id=7b51481e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b51481e",
  null
  
)

export default component.exports